import moment from 'moment-timezone'

const format = 'DD.MM.YYYY'

/**
 * @member {Object} form
 * @member {Object} form.application
 * @member {String} form.application.period_of
 * @member {String} form.application.period_to
 * @member {String} form.application.time_type
 * @member {Boolean} isNew
 * @member {Boolean} isEdit
 * @member {PassAccessDto[]} passAccesses
 * @member {TimeTypeDto|null} rangeTimeType
 * @member {String} timezone
 */
export default {
  watch: {
    startDatePeriod: function () {
      this.setPeriodOf(moment.tz(this.form.application.period_of, format, this.timezone))
    },
    endDatePeriod: function () {
      this.setPeriodTo(moment.tz(this.form.application.period_to, format, this.timezone))
    },
    'form.application.pass_access'(val) {
      this.setPeriodTo(moment.tz(this.form.application.period_to, format, this.timezone))
    }
  },

  computed: {
    /**
     * @return {{from: moment.Moment, to: moment.Moment}}
     */
    endDatePeriod() {
      const timeType = this.rangeTimeType

      if (timeType == null) {
        return this.unlimitedRange
      }

      const minStartDate = this.startDatePeriod.from
      const maxStartDate = this.startDatePeriod.to
      let endDate = moment().tz(this.timezone)
      if (this.form.application.period_of) {
        endDate = moment.tz(this.form.application.period_of, format, this.timezone)
      }
      if (endDate.isBefore(minStartDate, 'day')) {
        endDate = minStartDate.clone().add(1, 'd')
      }
      if (endDate.isAfter(maxStartDate, 'day')) {
        endDate = maxStartDate.clone()
      }

      let minCountDays = timeType.min_count_days
      let maxCountDays = timeType.max_count_days

      if (timeType.days_after_end_of_year !== null) {
        let endOfYear = endDate.clone().endOf('year').startOf('day')
        let daysToEndOfYear = endOfYear.diff(endDate, 'days')

        maxCountDays = daysToEndOfYear + timeType.days_after_end_of_year
        const leapYear = endOfYear.isLeapYear()
        const leapDay = endOfYear.clone().month(1).date(29)

        if (leapYear && endDate.isBefore(leapDay) && leapDay.isBefore(endDate.clone().add(maxCountDays, 'd'))) {
          maxCountDays += 1
        }
      }

      const from = endDate.clone().add(minCountDays, 'd')
      const to = endDate.clone().add(maxCountDays, 'd')

      return { from, to }
    },

    /**
     * @return {{from: moment.Moment, to: moment.Moment}}
     */
    startDatePeriod() {
      const timeType = this.rangeTimeType

      if (timeType == null) {
        return this.unlimitedRange
      }

      const currentDate = moment().tz(this.timezone)
      const from = currentDate.clone()
      const to = currentDate.clone()
      const shiftAfter = moment.tz(
        currentDate.format('DD.MM.YYYY ') + timeType.start_day_time,
        'DD.MM.YYYY HH:mm:ss',
        this.timezone
      )

      const shiftDay = currentDate.isAfter(shiftAfter) ? 1 : 0

      from
        .add(timeType.min_days_before_start + shiftDay, 'd')
      to
        .add(timeType.max_days_before_start + shiftDay, 'd')

      if (from.isSame(to, 'day')) {
        to.add(1, 'd')
      }

      return { from, to }
    },

    unlimitedRange() {
      return {
        from: moment(-8.64E+15).tz(this.timezone),
        to: moment(8.64E+15).tz(this.timezone)
      }
    }
  },

  methods: {
    setPassAccess() {
      if (this.isNew) {
        const allowedAccesses = [this.form.application.time_type, 'all']

        const passAccess = this.passAccesses.find(passAccess => allowedAccesses.includes(passAccess.time_type))

        this.form.application.pass_access = passAccess?.id ?? 1
        this.form.application.time_of = passAccess?.time_of ?? '00:00'
        this.form.application.time_to = passAccess?.time_to ?? '23:59'
      }
    },

    /**
     * @param {moment.Moment} periodOf
     */
    setPeriodOf(periodOf) {
      const period = this.startDatePeriod
      if (periodOf.isBefore(period.from, 'day')) {
        periodOf = period.from.clone()
      }

      if (periodOf.isAfter(period.to, 'day')) {
        periodOf = period.to.clone()
      }

      this.form.application.period_of = periodOf.format(format)
    },

    /**
     * @param {moment.Moment} periodTo
     */
    setPeriodTo(periodTo) {
      const period = this.endDatePeriod
      if (periodTo.isBefore(period.from, 'day')) {
        periodTo = period.from.clone()
      }

      if (periodTo.isAfter(period.to, 'day')) {
        periodTo = period.to.clone()
      }

      if (this.form.application.time_of > this.form.application.time_to) {
        periodTo.add(1, 'd')
      }

      this.form.application.period_to = periodTo.format(format)
    }
  }
}
